import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, t) {
  return l(), o("svg", r, [...t[0] || (t[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "M15.79 3H5.684C4.758 3 4 3.736 4 4.636v11.455h1.684V4.636H15.79zm2.526 3.273H9.053c-.927 0-1.685.736-1.685 1.636v11.455c0 .9.758 1.636 1.685 1.636h9.263c.926 0 1.684-.736 1.684-1.636V7.909c0-.9-.758-1.636-1.684-1.636m0 13.09H9.053V7.91h9.263z"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const p = { render: n };
export {
  p as default,
  n as render
};
